import gql from 'graphql-tag';
import { CAMPAIGN_SAVED_TEMPLATE_FIELDS } from './campaignSavedTemplate.fragment';

export const SELECT_POST_MALONE_SAVED_TEMPLATE_MUTATION = gql`
  mutation SelectPostMaloneSavedTemplateMutation(
    $campaignId: ID!
    $postMaloneSavedTemplateId: ID!
    $categoryIds: [ID!]
  ) {
    selectPostMaloneSavedTemplate(
      campaignId: $campaignId
      postMaloneSavedTemplateId: $postMaloneSavedTemplateId
      categoryIds: $categoryIds
    ) {
      campaignSavedTemplate {
        ...CampaignSavedTemplateFields
      }
      errors
    }
  }
  ${CAMPAIGN_SAVED_TEMPLATE_FIELDS}
`;
